import PageWrapper from "./PageWrapper";
import styled from "styled-components";
import GithubImg from "./assets/github.png";
import KaistLogo from "./assets/kaist.png";

const idx = [1, 4, 10, 12, 48, 50];

const MainPage = (props) => {
  return (
    <PageWrapper>
      <FlexWrapper style={{ gap: "20px" }}>
        <FlexWrapper style={{ gap: "2px" }}>
          <div style={{ fontWeight: 600, fontSize: "50px" }}>MultiDreamer</div>
          <div style={{ fontWeight: 500, fontSize: "30px" }}>
            : Generating a 3D mesh from a Single-view Multi-objects Image
          </div>
        </FlexWrapper>

        <div style={{ fontWeight: 400, fontSize: "20px" }}>
          Hae Chan Kim, Hanbee Jang, Hyewon Lee
        </div>
      </FlexWrapper>

      <FlexWrapper style={{ gap: "8px", margin: "40px 0" }}>
        <div
          style={{
            fontWeight: 500,
            fontSize: "15px",
            color: "gray",
            fontStyle: "italic",
          }}
        >
          Click to watch our Examples!
        </div>
        <DemoBlockContainer>
          {idx.map((idx) => (
            <DemoBlock key={idx} index={idx} onClick={props.onClickDemo(idx)} />
          ))}
        </DemoBlockContainer>
      </FlexWrapper>

      <FlexWrapper
        style={{ flexDirection: "row", gap: "10px", paddingBottom: "10px" }}
      >
        <GithubButton />
        <img src={KaistLogo} style={{ height: "40px" }} />
      </FlexWrapper>
    </PageWrapper>
  );
};
export default MainPage;

const FlexWrapper = styled.div`
  width: fit-content;
  height: fit-content;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const GithubButton = () => {
  return (
    <GithubButtonWrapper
      onClick={() => window.open("https://github.com/HaeChan0305/MultiDreamer")}
    >
      <img src={GithubImg} style={{ height: "80%" }} />
      <div style={{ fontSize: "18px", color: "white", fontWeight: 600 }}>
        Github
      </div>
    </GithubButtonWrapper>
  );
};

const GithubButtonWrapper = styled.div`
  width: 116px;
  height: 40px;

  box-sizing: border-box;
  padding: 3px 12px;
  border-radius: 5px;

  font-family: sans-serif;

  background-color: #444444;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  cursor: pointer;
`;

const DemoBlock = (props) => {
  return (
    <DemoBlockWrapper onClick={props.onClick}>
      <DemoImg src={`/thumb/${props.index}_thumb.png`} />
    </DemoBlockWrapper>
  );
};
const DemoBlockWrapper = styled.div`
  width: 160px;
  height: 160px;

  background-color: black;
  cursor: pointer;
`;

const DemoImg = styled.img`
  width: 100%;
  transition: all 0.3s;
  &:hover {
    opacity: 70%;
  }
`;

const DemoBlockContainer = styled.div`
  max-width: 520px;

  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
`;
